import { InspectionPointDto } from 'providers/api';

// The spool's name is the point's name; the point's own name is only a fallback for a point without a named spool.
const inspectionPointDisplayName = (inspectionPoint: InspectionPointDto, spoolName?: string): string => (
  spoolName?.trim() || inspectionPoint.name
);

export default inspectionPointDisplayName;
